var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.492,
    height: 9.58,
    viewBox: "0 0 18.492 9.58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M434.208,1055.427c-1.048-.252-.964-.629-1.761-.629-.3,0-2,.094-4.022.209a59.429,59.429,0,0,0-4.954-3.331,4.391,4.391,0,0,0-1.316.067c-.132.1,2.251,2.176,2.472,2.745a5.974,5.974,0,0,1,.206.724c-2.249.128-4.145.231-4.249.214-.252-.042-1.174-1.3-1.593-1.3h-1.383c.209.335,1.006,1.886.838,2.18s-.545.838-.084,1.006c.211.077,3.145.154,6.417.2a7.145,7.145,0,0,1-.247.9c-.221.569-2.6,2.648-2.472,2.745a4.375,4.375,0,0,0,1.316.067c.3-.018,4.115-2.729,5.443-3.68,2.427.01,4.475-.008,5.053-.067,1.635-.168,2.138-.713,2.222-1.006s-.838-.8-1.886-1.048Z",
    transform: "translate(-417.608 -1051.662)",
    fill: "#ccc"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlight);
export default __webpack_public_path__ + "static/media/flight.b8c6e8e0c8c9c96cf775eed3d493a084.svg";
export { ForwardRef as ReactComponent };